// These are the hardcoded form IDs used in specific flows.
// These can eventually be exposed in the app builder for selection.
export enum FormID {
  BENEFICIARY_FORM = 'beneficiaryForm',
  ACCOUNT_NAME_FORM = 'accountName',
  ONBOARDING_FLOW = 'onboardingFlow',
  VERIFICATION_FORM = 'verificationForm',
  WITHDRAWAL_FORM = 'withdraw-form',
  DEPOSIT_FORM = 'deposit',
  INTERNAL_TRANSFER_FORM = 'internalTransfer',
  OPEN_NEW_ACCOUNT_FORM = 'openNewAccountForm',
  CLOSING_ACCOUNT_FORM = 'closingAccountForm',
  MATURITY_DECISION = 'maturityDecisionForm',
  MARKETING_PREFERENCES_FORM = 'marketingPreferencesForm',
  UPDATE_USER_PROFILE = 'updateUserProfile',
  INITIATE_PAYMENT_FORM = 'initiatePaymentForm',
  UPDATE_NOMINATED_BANK_ACCOUNT_FORM = 'updateNominatedBankAccountForm',
  NEW_SUPPORT_CHAT_FORM = 'newSupportChatForm',
  INVITE_JOINT_ACCOUNT = 'inviteJointAccount',
  BUSINESS_ONBOARDING_FLOW = 'businessOnboardingFlow',
  SPENDING_BUDGET_FORM = 'spendingBudgetForm',
  ADD_CARD_FORM = 'addCardForm',
  SAVE_TRANSACTION_NOTE_FORM = 'saveTransactionNoteForm',
  BULK_PAYMENT_ADD_BENEFICIARY = 'bulkPaymentAddBeneficiary',
  PISP_RECURRING_DEPOSIT_FORM = 'pispRecurringDepositForm',
}

export const FORM_ID_DESCRIPTIONS: Record<FormID, string> = {
  [FormID.BENEFICIARY_FORM]: 'Add or edit beneficiary details',
  [FormID.ACCOUNT_NAME_FORM]: 'Update account nickname',
  [FormID.ONBOARDING_FLOW]: 'Onboarding an end user',
  [FormID.VERIFICATION_FORM]: 'Verify onboarding details',
  [FormID.WITHDRAWAL_FORM]: 'Initiate a withdrawal',
  [FormID.DEPOSIT_FORM]: 'Record or initiate a deposit',
  [FormID.INTERNAL_TRANSFER_FORM]: 'Transfer funds between your accounts',
  [FormID.OPEN_NEW_ACCOUNT_FORM]: 'Open a new account',
  [FormID.CLOSING_ACCOUNT_FORM]: 'Request account closure',
  [FormID.MATURITY_DECISION]: 'Recording a maturity decision',
  [FormID.MARKETING_PREFERENCES_FORM]: 'Manage marketing preferences',
  [FormID.UPDATE_USER_PROFILE]: 'Update user profile',
  [FormID.INITIATE_PAYMENT_FORM]: 'Initiate a payment',
  [FormID.UPDATE_NOMINATED_BANK_ACCOUNT_FORM]: 'Update nominated bank account',
  [FormID.NEW_SUPPORT_CHAT_FORM]: 'Start a new support chat',
  [FormID.INVITE_JOINT_ACCOUNT]: 'Invite joint account holder',
  [FormID.BUSINESS_ONBOARDING_FLOW]: 'Business onboarding flow',
  [FormID.SPENDING_BUDGET_FORM]: 'Spending Budget Management',
  [FormID.ADD_CARD_FORM]: 'Add a new card',
  [FormID.SAVE_TRANSACTION_NOTE_FORM]: 'Save a transaction note',
  [FormID.BULK_PAYMENT_ADD_BENEFICIARY]: 'Add beneficiary for bulk payment',
  [FormID.PISP_RECURRING_DEPOSIT_FORM]: 'PISP Recurring Deposit Form',
};
